import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "store";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useGetAllActionTrackerQuery } from "store/slices/apis/actionTrackerSlice";
import TableComponent from "components/grid";
import CustomPagination from "components/CustomPagination";
import { RxCross2 } from "react-icons/rx";
import StatusBadge from "components/badge/StatusBadge";
import RiskSeverityBadge from "components/badge/RiskSeverityBadge";
import moment from "moment";
import { useGetAllProjectRiskQuery } from "store/slices/apis/projectRiskSlice";

const RiskListPopUp = (props) => {
    const { header, open, handleClose, data } = props;
    const { projectId } = useParams();
    const [loading, setLoading] = useState(false);

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);

    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');

    // page size
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);

    const actionTrackerList = useGetAllProjectRiskQuery({ ...data, ProjectId: projectId, SortBy: sortBy, SortOrder: sortOrder, PageNumber: pageNumber, PageSize: pageSize })

    const dispatch = useDispatch();


    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';

        // const updatedFilters = {
        //     ...filters,
        //     SortBy: property,
        //     SortOrder: isAsc ? 'desc' : 'asc'
        // };

        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
    };

    const handleMenuOpen = (event, row) => {
        event.stopPropagation(); // prevent row click if any
        setMenuAnchorEl(event.currentTarget);
        setMenuRow(row);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setMenuRow(null);
    };

    // React.useEffect(() => {
    //     if (addActionTrackerRes?.isSuccess) {
    //         if (!addActionTrackerRes?.data?.status) {
    //             openNotification(addActionTrackerRes?.data?.message, 'success')
    //             handleClose();
    //         } else {
    //             openNotification(addActionTrackerRes?.data?.message, 'error')
    //         }
    //     }
    // }, [addActionTrackerRes?.isSuccess]);


    // React.useEffect(() => {
    //     if (addActionTrackerRes?.isError) {
    //         if (addActionTrackerRes?.error?.data?.status == 'fail') {
    //             openNotification(addActionTrackerRes?.error?.data?.message, 'error')
    //         } else {
    //             openNotification('Something went wrong!', 'error')
    //         }
    //         // cancel();
    //     }
    // }, [addActionTrackerRes?.isError]);

    const columns = [
        // {
        //     name: "",
        //     field: "actions",
        //     width: "10px",
        //     sticky: true,
        //     renderer: (row) => (
        //         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        //             <IconButton
        //                 size="small"
        //                 onClick={(e) => handleMenuOpen(e, row)}
        //             >
        //                 <MoreVertIcon fontSize="small" />
        //             </IconButton>
        //         </Box>
        //     ),
        // },
        {
            name: "ID",
            field: "customId",
            width: "130px",
            sticky: true,
        },
        {
            name: "Title",
            field: "title",
            width: "360px",
            sticky: true,
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {/* <Avatar
                            sx={{
                                width: 30,
                                height: 30,
                                bgcolor: getAvatarColor(row.category),
                                color: "#fff",
                                fontSize: "14px",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                            }}
                        >{row?.category?.[0] || "?"}</Avatar> */}
                    {row?.title}
                </Box>
            ),
        },
        {
            name: "Category",
            field: "category",
            sticky: true,
        },
        {
            name: 'Status',
            field: 'riskStatus',
            renderer: (row) => (
                <StatusBadge status={row?.riskStatus} />
            )
        },
        {
            name: "Likelihood",
            field: "likelihood",
        },
        {
            name: "Impact",
            field: "impact",
        },
        {
            name: "Risk Rating",
            field: "riskRating",
        },
        {
            name: "Severity",
            field: "severity",
            renderer: (row) => (
                <RiskSeverityBadge status={row?.severity} />
            )
        },
        {
            name: "Mitigation Action Status",
            field: "mitigationActionStatus",
        },
        {
            name: "Target Closure Date",
            field: "targetClosureDate",
            renderer: (row) => (
                row?.targetClosureDate ? moment.utc(row.targetClosureDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "Entity/Person Responsible",
            field: "entityPersonResponsible",
        },
    ];

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    {header}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ md: 12 }}>
                        <TableComponent
                            columns={columns}
                            data={actionTrackerList?.data?.data}
                            createSortHandler={handleRequestSort}
                            loading={loading}
                            order={sortOrder}
                            orderBy={sortBy}
                        />
                    </Grid>
                    <Grid size={{ md: 12 }}>
                        <CustomPagination
                            totalCount={actionTrackerList?.data?.totalRecords || 0}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageChange={handlePageChange}
                            setCurrentPage={setPageNumber}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default RiskListPopUp;
